import server from './base';

//
const { MALL_BASE_URL } = server;
export default {
  // 活动信息
  '/shop-product-list/getActivity': {
    method: 'POST',
    action: '/shop-product-list/getActivity',
    baseURL: MALL_BASE_URL
  }
};
